import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { SnackbarDisplay } from '@applied/dragonfruit/src/components/PageSnackbar';
import { SnackbarProvider } from '@applied/dragonfruit/src/components/PageSnackbar/snackbar_provider';
import useStableInstance from '@applied/utils/hooks/useStableInstance';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ConfigContextProvider, FontToggle } from 'api/config';

import { AppRoutes } from 'components/AppRoutes';

// Make sure we take out unusual default browser styles.
import 'css_reset.scss';
import 'app.scss';

/**
 * App is the React entrypoint for rendering the application.
 * It wraps the App Routes with various necessary providers.
 */
export function App(): React.JSX.Element {
  const queryClient = useStableInstance(() => new QueryClient());
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <SnackbarProvider>
          <ConfigContextProvider>
            <FontToggle />
            <div className="candidate_experience-app">
              <SnackbarDisplay />
              <AppRoutes />
            </div>
          </ConfigContextProvider>
        </SnackbarProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
